import { render, staticRenderFns } from "./VeneerLogImages.vue?vue&type=template&id=1941b222&"
import script from "./VeneerLogImages.vue?vue&type=script&lang=js&"
export * from "./VeneerLogImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1941b222')) {
      api.createRecord('1941b222', component.options)
    } else {
      api.reload('1941b222', component.options)
    }
    module.hot.accept("./VeneerLogImages.vue?vue&type=template&id=1941b222&", function () {
      api.rerender('1941b222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/detail/VeneerLogImages.vue"
export default component.exports